import { isValidJson } from '@resider/utils';
import filters from '../store';
import dictionaries from '@resider/dictionaries';
import { get } from 'svelte/store';

/**
 * 
 * @param {URLSearchParams} searchParams 
 * @param {any} [params] 
 * @returns 
 */
export default function sync(searchParams, params) {
	const arrayFilters = [
		'amenities',
		'building_type',
		'business_type',
		'city',
		'district',
		'interior_standard',
		'market',
		'price_change',
		'subdistrict'
	];

	const minmaxFilters = [
		'area',
		'build_year',
		'building_floors_num',
		'distance_to_subway',
		'floor_num',
		'inserted_at',
		'plot_area',
		'price',
		'rooms_num',
		'unit_price'
	];

	const numberFilters = ['lat', 'lon', 'max_transport_time', 'radius'];

	const stringFilters = ['description', 'destination', 'offer_type'];

	if (searchParams.has('offers_since')) {
		filters.update((store) => ({
			...store,
			offers_since: searchParams.get('offers_since') ?? 'all-time'
		}));
	}

	if (searchParams.has('sort_by')) {
		filters.update((store) => ({
			...store,
			sort_by: searchParams.get('sort_by') ?? 'accuracy'
		}));
	}

	for (const filterKey of arrayFilters) {
		if (searchParams.has(filterKey)) {
			filters.update((store) => ({
				...store,
				[filterKey]:
					isValidJson(`${searchParams.get(filterKey)}`) && filterKey.match(/interior_standard/)
						? JSON.parse(`${searchParams.get(filterKey)}`).map((/** @type {number} */ x) => `${x}`)
						: isValidJson(`${searchParams.get(filterKey)}`)
							? JSON.parse(`${searchParams.get(filterKey)}`)
							: []
			}));
		}
	}

	for (const filterKey of stringFilters) {
		filters.update((store) => ({
			...store,
			[filterKey]: searchParams.get(filterKey)
		}));
	}

	for (const filterKey of numberFilters) {
		if (searchParams.has(filterKey)) {
			filters.update((store) => ({
				...store,
				[filterKey]: Number(searchParams.get(filterKey))
			}));
		}
	}

	for (const filterKey of minmaxFilters) {
		if (searchParams.has(filterKey)) {
			if (isValidJson(`${searchParams.get(filterKey)}`)) {
				filters.update((store) => ({
					...store,
					[filterKey]:
						JSON.parse(`${searchParams.get(filterKey)}`)?.min &&
							!JSON.parse(`${searchParams.get(filterKey)}`)?.max
							? { min: JSON.parse(`${searchParams.get(filterKey)}`)?.min, max: null }
							: JSON.parse(`${searchParams.get(filterKey)}`)?.max &&
								!JSON.parse(`${searchParams.get(filterKey)}`)?.min
								? { min: null, max: JSON.parse(`${searchParams.get(filterKey)}`)?.max }
								: JSON.parse(`${searchParams.get(filterKey)}`)?.min &&
									JSON.parse(`${searchParams.get(filterKey)}`)?.max
									? {
										min: JSON.parse(`${searchParams.get(filterKey)}`)?.min,
										max: JSON.parse(`${searchParams.get(filterKey)}`)?.max
									}
									: { min: null, max: null }
				}));
			}
		}
	}

	if (params?.offer_type) {
		filters.update((store) => ({
			...store,
			offer_type: params?.offer_type.match(/rent|wynajem/) ? 'rent' : 'sale'
		}));
	} else if (searchParams.has('offer_type')) {
		filters.update((store) => ({
			...store,
			offer_type: `${searchParams.get('offer_type')}`
		}));
	}

	if (params?.city) {
		filters.update((store) => ({
			...store,
			city: params?.city.split(',').map((/** @type {String} */ x) => dictionaries.locations.cities.mazowieckie[x])
		}));
	}

	if (params?.city && params?.district) {
		filters.update((store) => ({
			...store,
			district: params?.district
				.split(',')
				.some((/** @type {String} */ x) => Object.keys(dictionaries.locations.districts[params.city]).includes(x))
				? params?.district
					.split(',')
					.map((/** @type {String} */ x) => dictionaries.locations.districts[params.city][x])
					?.filter((/** @type {string | undefined} */ x) => x !== undefined)
				: [],
			subdistrict: params?.district
				.split(',')
				.some((/** @type {String} */ x) =>
					Object.keys(dictionaries.locations.subdistricts[params.city]).includes(x)
				)
				? params?.district
					.split(',')
					.map((/** @type {String} */ x) => dictionaries.locations.subdistricts[params.city][x])
					?.filter((/** @type {string | undefined} */ x) => x !== undefined)
				: []
		}));
	}

	if (params?.city && params?.subdistrict) {
		filters.update((store) => ({
			...store,
			subdistrict: params?.subdistrict
				.split(',')
				.some((/** @type {String} */ x) =>
					Object.keys(dictionaries.locations.subdistricts[params.city]).includes(x)
				)
				? params?.subdistrict
					.split(',')
					.map((/** @type {String} */ x) => dictionaries.locations.subdistricts[params.city][x])
				: []
		}));
	}

	return get(filters);
}
